import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { Fragment } from 'react';
import Button from '../../../components/Button';
import Select from '../../../components/Select';
import FilterPopover from './FilterPopover';

const resourcesSelectOptions = [
  [
    { label: 'Medical', value: '1' },
    { label: 'Dental', value: '2' },
    { label: 'Vision', value: '3' },
    { label: 'Disability', value: '4' },
    { label: 'Long-Term Diability', value: '5' },
    { label: 'Spousal Surcharge', value: '6' },
    { label: 'Live & Accidental Death', value: '7' },
  ],
  [
    { label: 'Cigna', value: '1' },
    { label: 'MetLife', value: '2' },
    { label: 'Liberty Mutual', value: '3' },
    { label: 'VSP', value: '4' },
  ],
  [
    { label: 'Cigna', value: '1' },
    { label: 'MetLife', value: '2' },
    { label: 'Liberty Mutual', value: '3' },
    { label: 'VSP', value: '4' },
  ],
];

const transactionSelectOptions = [
  [
    { label: 'Medical', value: '1' },
    { label: 'Dental', value: '2' },
    { label: 'Vision', value: '3' },
    { label: 'Disability', value: '4' },
    { label: 'Long-Term Diability', value: '5' },
    { label: 'Spousal Surcharge', value: '6' },
    { label: 'Live & Accidental Death', value: '7' },
  ],
  [
    { label: 'Cigna', value: '1' },
    { label: 'MetLife', value: '2' },
    { label: 'Liberty Mutual', value: '3' },
    { label: 'VSP', value: '4' },
  ],
  [
    { label: 'Cigna', value: '1' },
    { label: 'MetLife', value: '2' },
    { label: 'Liberty Mutual', value: '3' },
    { label: 'VSP', value: '4' },
  ],
  [
    { label: 'Deleted', value: '1' },
    { label: 'Completed', value: '2' },
    { label: 'Pending', value: '3' },
  ],
];

const FilterPopoverDemo = () => {
  const ResourcesFilter = (
    <Fragment>
      <h6 className={'h6 mb-0'}>{'Filter'}</h6>
      <Select
        placeholder="Benefit Type"
        options={resourcesSelectOptions[0]}
        className={'mt-7'}
      />
      <Select
        placeholder="Title"
        options={resourcesSelectOptions[1]}
        className={'mt-7'}
      />
      <Select
        placeholder="Title"
        options={resourcesSelectOptions[2]}
        className={'mt-7'}
      />
    </Fragment>
  );

  const TransactionFilter = (
    <Fragment>
      <h6 className={'h6 mb-0'}>{'Filter'}</h6>
      <Select
        placeholder="Service"
        options={transactionSelectOptions[0]}
        className={'mt-7'}
      />
      <Select
        placeholder="Plan Name"
        options={transactionSelectOptions[1]}
        className={'mt-7'}
      />
      <Select
        placeholder="Transaction Type"
        options={transactionSelectOptions[2]}
        className={'mt-7'}
      />
      <Select
        placeholder="Status"
        options={transactionSelectOptions[3]}
        className={'mt-7'}
      />
    </Fragment>
  );

  return (
    <div className="d-flex justify-content-center">
      <div className="me-12">
        <FilterPopover
          onFilter={() => console.log("I'm filtered")}
          popoverBody={ResourcesFilter}
        >
          <Button leftIcon={light('filter')}>{'Filter'}</Button>
        </FilterPopover>
      </div>

      <FilterPopover
        onFilter={() => console.log("I'm filtered")}
        popoverBody={TransactionFilter}
      >
        <Button leftIcon={light('filter')}>{'Filter'}</Button>
      </FilterPopover>
    </div>
  );
};

export default FilterPopoverDemo;
